import React, { Component } from 'react';

export default class TreeNode extends Component {
}
